    <template>
        <div v-if="visible" class="ai-dialog-overlay">
            <div class="ai-dialog">
                <!-- header -->
                <div class="ai-dialog-header">
                    <h2>{{ typeDialogAI == ACTION_AI_COMPOSE.COMPOSE_MAIL ? $t('zimbraNokey.composeNew') : $t('zimbraNokey.composeNew') }}</h2>
                    <button class="ai-dialog-close" @click="close">X</button>
                </div>

                <!-- body -->
                <div class="ai-dialog-body">
                    <el-input :autofocus="true" type="textarea" :rows="10" v-model="content"
                              :placeholder="typeDialogAi == ACTION_AI_COMPOSE.COMPOSE_MAIL ? $t('zimbraNokey.promptAi') : $t('zimbraNokey.contentCustomAI')"></el-input>
                </div>

                <!-- footer -->
                <div class="ai-dialog-footer" style="align-content: end">
                    <div>
                        <button class="ai-btn-cancel mr-2" @click="close">
                            {{ $t('zimbra.ztMsg.cancel') }}
                        </button>
                        <button class="ai-btn-submit" @click="submit">
                            {{ $t('zimbra.ztMsg.create') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <script>
    import { ACTION_AI_COMPOSE } from "@/utils/constants";

    export default {
        name: "AIComposeDialog",
        props: {
            typeDialogAi: {type: String, required: true},
            visible: { type: Boolean, default: false },
        },
        data() {
            return {
                content: "",
                ACTION_AI_COMPOSE: ACTION_AI_COMPOSE
            };
        },
        methods: {
            close() {
                this.$emit("close");
                this.content = "";
            },
            submit() {
                this.$emit("submit", {content : this.content, type: this.typeDialogAi});
                this.close();
            },
        },
    };
    </script>

    <style scoped>
    .ai-dialog-overlay {
        position: fixed;
        inset: 0;
        background: rgb(210 210 210 / 50%);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }
    .ai-dialog {
        background: #fff;
        border-radius: 8px;
        width: 800px;
        max-width: 90%;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
        overflow: hidden;
    }
    .ai-dialog-header{
        padding: 12px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h2{
            font-weight: bolder;
        }
    }
    .ai-dialog-footer{
        padding: 12px 16px;
        display: flex;
        justify-content: end;
    }
    .ai-dialog-body {
        padding: 16px;
    }
    .ai-dialog-body textarea {
        width: 100%;
        height: 120px;
        resize: none;
    }
    .ai-btn-cancel {
        background: #f5f5f5;
        border: none;
        padding: 6px 12px;
        cursor: pointer;
    }
    .ai-btn-submit {
        background: var(--color-primary);
        border: none;
        color: #fff;
        padding: 6px 12px;
        border-radius: 4px;
        cursor: pointer;
    }
    </style>
